var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bet-history-list" }, [
    _c("div", { staticClass: "bet-history-list__toolbar" }, [
      _c(
        "div",
        { staticClass: "bet-history-list__filters" },
        [
          _c("SelectBox", {
            staticClass: "bet-history-list__date-select",
            attrs: {
              default: _vm.historySelection || "Today",
              options: _vm.dateOptions,
            },
            on: { update: _vm.updateDateHandler },
          }),
          _c(
            "button",
            {
              staticClass: "bet-history-list__pill",
              class: { "is-active": _vm.productFilter === "all" },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.updateProductFilterHandler("all")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("All")) + " ")]
          ),
          _c(
            "button",
            {
              staticClass:
                "bet-history-list__pill bet-history-list__pill--icon",
              class: { "is-active": _vm.productFilter === "tai-xiu" },
              attrs: { type: "button", "aria-label": "Tai Xiu" },
              on: {
                click: function ($event) {
                  return _vm.updateProductFilterHandler("tai-xiu")
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/dice-menu.webp"),
                  alt: "",
                },
              }),
            ]
          ),
          _c(
            "button",
            {
              staticClass:
                "bet-history-list__pill bet-history-list__pill--icon",
              class: { "is-active": _vm.productFilter === "cockfight" },
              attrs: { type: "button", "aria-label": "Cockfight" },
              on: {
                click: function ($event) {
                  return _vm.updateProductFilterHandler("cockfight")
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/cockfight-menu-icon.svg"),
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
      _c("span", { staticClass: "bet-history-list__date-label" }, [
        _vm._v(_vm._s(_vm.displayDate)),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "result-main-body" },
      [
        _c("BetHistoryTable"),
        _vm.hasMoreTicket
          ? _c(
              "button",
              { staticClass: "load-more", on: { click: _vm.loadMoreTickets } },
              [_vm._v(_vm._s(_vm.loadMoreText))]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }